module.exports = __webpack_public_path__ + "static/media/save_icon.b4b16cdf.svg";